import { MenuItem, Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicTable from "../../../components/dynamicTable";
import CustomDropDown from "../../../components/select";
import { setSelectedCardStatusSaver } from "../../../lib/redux/slices/searchKeysSlice";
import { useNavigate } from "react-router-dom";

const tableHeader = [
  "Prospect Details",
  "Connect Details",
  "Sale Value",
  "Status",
  "Sale Status",
  "Detail",
];

const displayRows = [
  "customer_details",
  "connectDetails",
  "paymentDetails",
  "contract_status",
  "saleStatus",
  "actions",
];

const CompletedConnection = ({ allContracts, cardsData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  const handleNavigateToDetail = (row, index) => {
    navigate("/prospect-details", { state: { data: row } });
  };

  return (
    <React.Fragment>
      <Stack my={2}>
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2.125rem" }}
        >
          All Leads{" "}
        </Typography>
      </Stack>

      <Stack
        my={2}
        px={1}
        py={2}
        gap={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        bgcolor={"primary.light"}
        flexWrap={"wrap"}
      >
        <Stack direction={{ sm: "row" }} alignItems={"center"} gap={2}>
          <Typography
            variant={"body2"}
            fontSize={"0.75rem"}
            color={"secondary.dark"}
          >
            Prospects ({allContracts?.length})
          </Typography>

          <CustomDropDown
            value={searchKeys?.selectedCardStatusSaver}
            onChange={(e) =>
              dispatch(setSelectedCardStatusSaver(e.target.value))
            }
            size={"small"}
            stylePropos={{
              width: "250px",
              "& .MuiInputBase-root": {
                backgroundColor: "white",
              },
            }}
          >
            {/* <MenuItem value={searchBy}>All</MenuItem> */}
            {cardsData.map((val) => {
              return (
                <MenuItem key={val.id} value={val.type}>
                  {`${val.title}  (${val.count})`}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Stack>
      </Stack>

      <DynamicTable
        tableData={allContracts || []}
        displayRows={displayRows}
        tableHeader={tableHeader}
        showDetail={true}
        handleNavigateToDetail={handleNavigateToDetail}
      />

      {allContracts && allContracts?.length === 0 && (
        <Typography variant="h5" fontWeight={500} textAlign={"center"}>
          {" "}
          No Data Found
        </Typography>
      )}
    </React.Fragment>
  );
};

export default CompletedConnection;
